import { render, staticRenderFns } from "./ShiftClose.vue?vue&type=template&id=0af9d643&"
import script from "./ShiftClose.vue?vue&type=script&lang=ts&"
export * from "./ShiftClose.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports